export enum OrderStatusEnum {
  Created = 1,
  Unassigned = 2,
  Assigned = 3,
  Pending = 4,
  Accepted = 5,
  Processing = 6,
  Updated = 7,
  Completed = 12,
  Canceled = 9,
  QAPending = 15,
  QASubmitted = 16,
  RevisionRequested = 17,
  InspectionAccepted = 18,
  PendingFloorplan = 19,
  PendingFinalReport = 20, // Waiting for the Final report
  FinalReport = 21
}
